import React, { useEffect, useState } from 'react';
import { Editor as WysiwygEditor } from 'react-draft-wysiwyg';
import { convertToRaw, ContentState, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import PropTypes from 'prop-types';

import 'assets/css/react-draft-wysiwyg.css';

/**
 * 위지윅 에디터
 */
const Editor = ({ value, onUpdate }) => {
  /* state */
  // 입력 값
  const [input, setInput] = useState(EditorState.createEmpty());
  // 초기 설정 여부
  const [isInit, setIsInit] = useState(false);

  /* watch */
  useEffect(() => {
    if (!value || isInit) {
      return;
    }

    const { contentBlocks, entityMap } = htmlToDraft(value) ?? {};

    setInput(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(contentBlocks, entityMap)
      )
    );
    setIsInit(true);
  }, [value]);

  /* event */
  // 입력 값 변경 시
  const onChange = editorState => {
    setInput(editorState);
    onUpdate?.(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  /* view */
  return (
    <WysiwygEditor
      wrapperClassName="bg-white border min-vh-50"
      editorClassName="p-3"
      editorState={input}
      onEditorStateChange={onChange}
    />
  );
};

Editor.propTypes = {
  // 값
  value: PropTypes.string,

  // 값 변경 시 이벤트
  onUpdate: PropTypes.func
};
Editor.defaultProps = { value: '' };

export default Editor;
